// Reporting tab access — Admin only (2026-09-11); a csr gets "My Stats" (the
// self-service per-agent view) instead. Extracted so
// it's unit-testable with node --test (no React harness available) — App.jsx's
// NavRail `show` conditions and the mode-gate ternary both call these, so the
// nav entry and the route gate can never drift out of sync with each other.
export function canSeeReportingTab(effectiveIsAdmin) {
  return effectiveIsAdmin
}

export function canSeeMyStatsTab(effectiveIsAdmin) {
  return !effectiveIsAdmin
}

// Forecasting tab (2026-10-16) -- Patrick's own working area within
// Reporting (busy-season volume/contact projections, still being designed),
// visible to no one else for now, not even other admins. The first
// single-person gate in this codebase (every other check here is role-
// based) -- deliberately a plain literal match on the live Entra
// upn/email claim (req.auth.username server-side, me.username here), the
// same field exact-identity checks already use elsewhere (e.g. the removed
// Schedule Hub pilot allowlist). Widen this to a real role/allowlist if
// the tab ever needs more than one viewer. MUST stay in sync with
// server/src/auth.js's requireForecastingOwner() -- this is the tab-
// visibility check only; the actual data routes behind the tab gate on
// that server-side check, not this one.
const FORECASTING_TAB_USERNAME = 'placroix@1aauto.com'
export function canSeeForecastingTab(username) {
  return username === FORECASTING_TAB_USERNAME
}
